import { __rest } from '../../_virtual/_tslib.js';
import { jsxs } from 'react/jsx-runtime';
import { forwardRef, useRef, useImperativeHandle } from 'react';
import { StyledChip } from './Chip.styles.js';

const Chip = forwardRef((props, ref) => {
    const { id = "", blockWidth = false, disabled = false, 
    // elevation = false,
    leftNode = null, rightNode = null, size = "medium", onClick, children, padded = true } = props, restProps = __rest(props, ["id", "blockWidth", "disabled", "leftNode", "rightNode", "size", "onClick", "children", "padded"]);
    const chipRef = useRef(null);
    useImperativeHandle(ref, () => chipRef.current);
    return (jsxs(StyledChip, Object.assign({}, restProps, { ref: chipRef, id: id, blockWidth: blockWidth, disabled: disabled, 
        // elevation={elevation}
        leftNode: leftNode, rightNode: rightNode, size: size, onClick: disabled ? undefined : onClick, padded: padded }, { children: [leftNode, " ", children, " ", rightNode] })));
});

export { Chip as default };
//# sourceMappingURL=Chip.js.map
